import cx from 'classnames'
import styles from './ImageLinkGroup.module.scss'
import { Heading, ImageLink, Paragraph } from '~elements'
import { ImageLinkGroupProps } from '~types'
import { Container } from 'react-grid-system'

const ImageLinkGroup = ({
  images,
  alignment = 'center',
  caption,
  headline,
  displayImagesInline,
  isChildOfFooter = false,
  linkLocation = null
}: ImageLinkGroupProps) => {
  const alignmentClasses = {
    left: styles.alignLeft,
    center: styles.alignCenter,
    right: styles.alignRight
  }
  const shouldWrapItems = alignment === 'center' && displayImagesInline && images.length >= 3

  return (
    <div className={cx(styles.imageGroupLinkContainer, isChildOfFooter && styles.isChildOfFooter)}>
      <Container>
        {headline && (
          <Heading level={6} justify='center'>
            {headline}
          </Heading>
        )}
        <div
          className={cx(
            styles.imageLinkContainer,
            alignmentClasses[alignment],
            displayImagesInline && styles.displayImagesInline,
            shouldWrapItems && styles.wrapItems
          )}
        >
          {images.map(image => (
            <ImageLink key={image.id} {...image} {...(linkLocation && { linkLocation })} />
          ))}
        </div>

        {caption && (
          <div className={styles.captionContainer}>
            <Paragraph text={caption} fontSize='lg' justify='center' />
          </div>
        )}
      </Container>
    </div>
  )
}

export default ImageLinkGroup
